/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthActivateAccountRouteImport } from './routes/_auth/activate-account'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthSessionEndedRouteImport } from './routes/_auth/session-ended'
import { Route as AuthedOrganizationRouteRouteImport } from './routes/_authed/_organization/route'
import { Route as AuthedAcceptInvitationRouteImport } from './routes/_authed/accept-invitation'
import { Route as AuthedAddOrganizationRouteImport } from './routes/_authed/add-organization'
import { Route as AuthedChooseOrganizationRouteImport } from './routes/_authed/choose-organization'
import { Route as AuthedGoRouteRouteImport } from './routes/_authed/go/route'
import { Route as AuthedSettingsRouteRouteImport } from './routes/_authed/settings/route'
import { Route as PTokenRouteImport } from './routes/p.$token'
import { Route as AuthAuthCallbackRouteImport } from './routes/_auth/auth.callback'
import { Route as AuthAuth0CallbackRouteImport } from './routes/_auth/auth0.callback'
import { Route as AuthedOrganizationIndexRouteImport } from './routes/_authed/_organization/index'
import { Route as AuthedOrganizationMyTasksRouteImport } from './routes/_authed/_organization/my-tasks'
import { Route as AuthedOrganizationNotificationsRouteImport } from './routes/_authed/_organization/notifications'
import { Route as AuthedOrganizationReleaseNotesRouteImport } from './routes/_authed/_organization/release-notes'
import { Route as AuthedProjectProjectIdRouteImport } from './routes/_authed/project/$projectId'
import { Route as AuthedSettingsClientsRouteImport } from './routes/_authed/settings/clients'
import { Route as AuthedSettingsMembersRouteImport } from './routes/_authed/settings/members'
import { Route as AuthedSettingsOrganizationsRouteImport } from './routes/_authed/settings/organizations'
import { Route as AuthedSettingsProcoreRouteImport } from './routes/_authed/settings/procore'
import { Route as AuthedSettingsProfileRouteImport } from './routes/_authed/settings/profile'
import { Route as AuthedSettingsSharepointRouteImport } from './routes/_authed/settings/sharepoint'
import { Route as AuthedSettingsSsoRouteImport } from './routes/_authed/settings/sso'
import { Route as AuthedSettingsSuppliersRouteImport } from './routes/_authed/settings/suppliers'
import { Route as AuthedSettingsWorkspacesRouteImport } from './routes/_authed/settings/workspaces'
import { Route as AuthedOrganizationLearningsIndexRouteImport } from './routes/_authed/_organization/learnings/index'
import { Route as AuthedGoEntityEntityIdRouteImport } from './routes/_authed/go/$entity.$entityId'
import { Route as AuthedGoTeamsLinkStateRouteImport } from './routes/_authed/go/teams-link.$state'
import { Route as AuthedProjectProjectIdIndexRouteImport } from './routes/_authed/project/$projectId/index'
import { Route as AuthedProjectProjectIdArtifactsRouteRouteImport } from './routes/_authed/project/$projectId/artifacts/route'
import { Route as AuthedProjectProjectIdInsightsRouteImport } from './routes/_authed/project/$projectId/insights'
import { Route as AuthedProjectProjectIdMembersRouteImport } from './routes/_authed/project/$projectId/members'
import { Route as AuthedProjectProjectIdSettingsRouteRouteImport } from './routes/_authed/project/$projectId/settings/route'
import { Route as AuthedProjectProjectIdTasksRouteImport } from './routes/_authed/project/$projectId/tasks'
import { Route as AuthedSettingsInternalCuratorRouteImport } from './routes/_authed/settings/internal/curator'
import { Route as AuthedSettingsInternalOrganizationsRouteImport } from './routes/_authed/settings/internal/organizations'
import { Route as AuthedSettingsKnowledgeBaseIndexRouteImport } from './routes/_authed/settings/knowledge-base/index'
import { Route as AuthedSettingsKnowledgeBaseNewFeedbackRouteImport } from './routes/_authed/settings/knowledge-base/new-feedback'
import { Route as AuthedSettingsTemplatesIndexRouteImport } from './routes/_authed/settings/templates/index'
import { Route as AuthedSettingsTemplatesTemplateIdRouteImport } from './routes/_authed/settings/templates/$templateId'
import { Route as AuthedSettingsTemplatesNewRouteImport } from './routes/_authed/settings/templates/new'
import { Route as AuthedOrganizationLearningsClientsClientIdRouteImport } from './routes/_authed/_organization/learnings/clients.$clientId'
import { Route as AuthedOrganizationLearningsPortfolioProjectTypeRouteImport } from './routes/_authed/_organization/learnings/portfolio.$projectType'
import { Route as AuthedProjectProjectIdArtifactsIndexRouteImport } from './routes/_authed/project/$projectId/artifacts/index'
import { Route as AuthedProjectProjectIdArtifactsArtifactIdRouteImport } from './routes/_authed/project/$projectId/artifacts/$artifactId'
import { Route as AuthedProjectProjectIdContractsSplatRouteImport } from './routes/_authed/project/$projectId/contracts/$'
import { Route as AuthedProjectProjectIdSettingsIndexRouteImport } from './routes/_authed/project/$projectId/settings/index'
import { Route as AuthedProjectProjectIdTenderPackagesSplatRouteImport } from './routes/_authed/project/$projectId/tender-packages/$'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId'
import { Route as AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRouteImport } from './routes/_authed/settings/knowledge-base/internal.$knowledgeBaseId'
import { Route as AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRouteImport } from './routes/_authed/settings/knowledge-base/tender-feedbacks.$tenderFeedbackId'
import { Route as AuthedProjectProjectIdArtifactsArtifactIdIndexRouteImport } from './routes/_authed/project/$projectId/artifacts/$artifactId.index'
import { Route as AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRouteImport } from './routes/_authed/project/$projectId/artifacts/$artifactId.version-history'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/route'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/contract-management/route'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/route'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/route'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/insights'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings/route'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/tasks'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/extractions'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/summary'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/work-packages'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/$documentId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/route'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/$ambiguityId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/$runId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/$conflictId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/$domain'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/$domain'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/scope-breakdown/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/$deviationId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId.index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId.version-history'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings/route'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/summary'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/$sheetId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/$clauseId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/$positionId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/$documentId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/$groupId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/$deliverableId'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/index'
import { Route as AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRouteImport } from './routes/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthActivateAccountRoute = AuthActivateAccountRouteImport.update({
  id: '/activate-account',
  path: '/activate-account',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSessionEndedRoute = AuthSessionEndedRouteImport.update({
  id: '/session-ended',
  path: '/session-ended',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthedOrganizationRouteRoute = AuthedOrganizationRouteRouteImport.update({
  id: '/_organization',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAcceptInvitationRoute = AuthedAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAddOrganizationRoute = AuthedAddOrganizationRouteImport.update({
  id: '/add-organization',
  path: '/add-organization',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedChooseOrganizationRoute =
  AuthedChooseOrganizationRouteImport.update({
    id: '/choose-organization',
    path: '/choose-organization',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedGoRouteRoute = AuthedGoRouteRouteImport.update({
  id: '/go',
  path: '/go',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRouteRoute = AuthedSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const PTokenRoute = PTokenRouteImport.update({
  id: '/p/$token',
  path: '/p/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAuthCallbackRoute = AuthAuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAuth0CallbackRoute = AuthAuth0CallbackRouteImport.update({
  id: '/auth0/callback',
  path: '/auth0/callback',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthedOrganizationIndexRoute = AuthedOrganizationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedOrganizationRouteRoute,
} as any)
const AuthedOrganizationMyTasksRoute =
  AuthedOrganizationMyTasksRouteImport.update({
    id: '/my-tasks',
    path: '/my-tasks',
    getParentRoute: () => AuthedOrganizationRouteRoute,
  } as any)
const AuthedOrganizationNotificationsRoute =
  AuthedOrganizationNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthedOrganizationRouteRoute,
  } as any)
const AuthedOrganizationReleaseNotesRoute =
  AuthedOrganizationReleaseNotesRouteImport.update({
    id: '/release-notes',
    path: '/release-notes',
    getParentRoute: () => AuthedOrganizationRouteRoute,
  } as any)
const AuthedProjectProjectIdRoute = AuthedProjectProjectIdRouteImport.update({
  id: '/project/$projectId',
  path: '/project/$projectId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsClientsRoute = AuthedSettingsClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsMembersRoute = AuthedSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsOrganizationsRoute =
  AuthedSettingsOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsProcoreRoute = AuthedSettingsProcoreRouteImport.update({
  id: '/procore',
  path: '/procore',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsProfileRoute = AuthedSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsSharepointRoute =
  AuthedSettingsSharepointRouteImport.update({
    id: '/sharepoint',
    path: '/sharepoint',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsSsoRoute = AuthedSettingsSsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsSuppliersRoute = AuthedSettingsSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => AuthedSettingsRouteRoute,
} as any)
const AuthedSettingsWorkspacesRoute =
  AuthedSettingsWorkspacesRouteImport.update({
    id: '/workspaces',
    path: '/workspaces',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedOrganizationLearningsIndexRoute =
  AuthedOrganizationLearningsIndexRouteImport.update({
    id: '/learnings/',
    path: '/learnings/',
    getParentRoute: () => AuthedOrganizationRouteRoute,
  } as any)
const AuthedGoEntityEntityIdRoute = AuthedGoEntityEntityIdRouteImport.update({
  id: '/$entity/$entityId',
  path: '/$entity/$entityId',
  getParentRoute: () => AuthedGoRouteRoute,
} as any)
const AuthedGoTeamsLinkStateRoute = AuthedGoTeamsLinkStateRouteImport.update({
  id: '/teams-link/$state',
  path: '/teams-link/$state',
  getParentRoute: () => AuthedGoRouteRoute,
} as any)
const AuthedProjectProjectIdIndexRoute =
  AuthedProjectProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedProjectProjectIdRoute,
  } as any)
const AuthedProjectProjectIdArtifactsRouteRoute =
  AuthedProjectProjectIdArtifactsRouteRouteImport.update({
    id: '/artifacts',
    path: '/artifacts',
    getParentRoute: () => AuthedProjectProjectIdRoute,
  } as any)
const AuthedProjectProjectIdInsightsRoute =
  AuthedProjectProjectIdInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthedProjectProjectIdRoute,
  } as any)
const AuthedProjectProjectIdMembersRoute =
  AuthedProjectProjectIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthedProjectProjectIdRoute,
  } as any)
const AuthedProjectProjectIdSettingsRouteRoute =
  AuthedProjectProjectIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedProjectProjectIdRoute,
  } as any)
const AuthedProjectProjectIdTasksRoute =
  AuthedProjectProjectIdTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthedProjectProjectIdRoute,
  } as any)
const AuthedSettingsInternalCuratorRoute =
  AuthedSettingsInternalCuratorRouteImport.update({
    id: '/internal/curator',
    path: '/internal/curator',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsInternalOrganizationsRoute =
  AuthedSettingsInternalOrganizationsRouteImport.update({
    id: '/internal/organizations',
    path: '/internal/organizations',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsKnowledgeBaseIndexRoute =
  AuthedSettingsKnowledgeBaseIndexRouteImport.update({
    id: '/knowledge-base/',
    path: '/knowledge-base/',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsKnowledgeBaseNewFeedbackRoute =
  AuthedSettingsKnowledgeBaseNewFeedbackRouteImport.update({
    id: '/knowledge-base/new-feedback',
    path: '/knowledge-base/new-feedback',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsTemplatesIndexRoute =
  AuthedSettingsTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsTemplatesTemplateIdRoute =
  AuthedSettingsTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsTemplatesNewRoute =
  AuthedSettingsTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedOrganizationLearningsClientsClientIdRoute =
  AuthedOrganizationLearningsClientsClientIdRouteImport.update({
    id: '/learnings/clients/$clientId',
    path: '/learnings/clients/$clientId',
    getParentRoute: () => AuthedOrganizationRouteRoute,
  } as any)
const AuthedOrganizationLearningsPortfolioProjectTypeRoute =
  AuthedOrganizationLearningsPortfolioProjectTypeRouteImport.update({
    id: '/learnings/portfolio/$projectType',
    path: '/learnings/portfolio/$projectType',
    getParentRoute: () => AuthedOrganizationRouteRoute,
  } as any)
const AuthedProjectProjectIdArtifactsIndexRoute =
  AuthedProjectProjectIdArtifactsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedProjectProjectIdArtifactsRouteRoute,
  } as any)
const AuthedProjectProjectIdArtifactsArtifactIdRoute =
  AuthedProjectProjectIdArtifactsArtifactIdRouteImport.update({
    id: '/$artifactId',
    path: '/$artifactId',
    getParentRoute: () => AuthedProjectProjectIdArtifactsRouteRoute,
  } as any)
const AuthedProjectProjectIdContractsSplatRoute =
  AuthedProjectProjectIdContractsSplatRouteImport.update({
    id: '/contracts/$',
    path: '/contracts/$',
    getParentRoute: () => AuthedProjectProjectIdRoute,
  } as any)
const AuthedProjectProjectIdSettingsIndexRoute =
  AuthedProjectProjectIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedProjectProjectIdSettingsRouteRoute,
  } as any)
const AuthedProjectProjectIdTenderPackagesSplatRoute =
  AuthedProjectProjectIdTenderPackagesSplatRouteImport.update({
    id: '/tender-packages/$',
    path: '/tender-packages/$',
    getParentRoute: () => AuthedProjectProjectIdRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdRouteImport.update({
    id: '/workspaces/$workspaceId',
    path: '/workspaces/$workspaceId',
    getParentRoute: () => AuthedProjectProjectIdRoute,
  } as any)
const AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRoute =
  AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRouteImport.update({
    id: '/knowledge-base/internal/$knowledgeBaseId',
    path: '/knowledge-base/internal/$knowledgeBaseId',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRoute =
  AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRouteImport.update({
    id: '/knowledge-base/tender-feedbacks/$tenderFeedbackId',
    path: '/knowledge-base/tender-feedbacks/$tenderFeedbackId',
    getParentRoute: () => AuthedSettingsRouteRoute,
  } as any)
const AuthedProjectProjectIdArtifactsArtifactIdIndexRoute =
  AuthedProjectProjectIdArtifactsArtifactIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedProjectProjectIdArtifactsArtifactIdRoute,
  } as any)
const AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRoute =
  AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRouteImport.update({
    id: '/version-history',
    path: '/version-history',
    getParentRoute: () => AuthedProjectProjectIdArtifactsArtifactIdRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthedProjectProjectIdWorkspacesWorkspaceIdRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteImport.update({
    id: '/bids',
    path: '/bids',
    getParentRoute: () => AuthedProjectProjectIdWorkspacesWorkspaceIdRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteImport.update(
    {
      id: '/contract-management',
      path: '/contract-management',
      getParentRoute: () => AuthedProjectProjectIdWorkspacesWorkspaceIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteImport.update(
    {
      id: '/subcontractor-bids',
      path: '/subcontractor-bids',
      getParentRoute: () => AuthedProjectProjectIdWorkspacesWorkspaceIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteImport.update(
    {
      id: '/artifacts',
      path: '/artifacts',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () =>
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () =>
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteImport.update(
    {
      id: '/$supplementId',
      path: '/$supplementId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteImport.update(
    {
      id: '/$procurementId',
      path: '/$procurementId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRouteImport.update(
    {
      id: '/(main)/extractions',
      path: '/extractions',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRouteImport.update(
    {
      id: '/(main)/summary',
      path: '/summary',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRouteImport.update(
    {
      id: '/(main)/work-packages',
      path: '/work-packages',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteImport.update(
    {
      id: '/$artifactId',
      path: '/$artifactId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRouteImport.update(
    {
      id: '/files/',
      path: '/files/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRouteImport.update(
    {
      id: '/files/$documentId',
      path: '/files/$documentId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteImport.update({
    id: '/$bidId/_layout',
    path: '/$bidId',
    getParentRoute: () =>
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRouteImport.update({
    id: '/$bidId/draft',
    path: '/$bidId/draft',
    getParentRoute: () =>
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRouteImport.update(
    {
      id: '/$bidId/methodology',
      path: '/$bidId/methodology',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute,
  } as any)
const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRouteImport.update(
    {
      id: '/files',
      path: '/files',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRouteImport.update(
    {
      id: '/leveling',
      path: '/leveling',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRouteImport.update(
    {
      id: '/reservations',
      path: '/reservations',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRouteImport.update(
    {
      id: '/scope-of-work',
      path: '/scope-of-work',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRouteImport.update(
    {
      id: '/(main)/ambiguities/',
      path: '/ambiguities/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRouteImport.update(
    {
      id: '/(main)/ambiguities/$ambiguityId',
      path: '/ambiguities/$ambiguityId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRouteImport.update(
    {
      id: '/(main)/checklists/',
      path: '/checklists/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRouteImport.update(
    {
      id: '/(main)/checklists/$runId',
      path: '/checklists/$runId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRouteImport.update(
    {
      id: '/(main)/clauses/',
      path: '/clauses/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRouteImport.update(
    {
      id: '/(main)/conflicts/',
      path: '/conflicts/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRouteImport.update(
    {
      id: '/(main)/conflicts/$conflictId',
      path: '/conflicts/$conflictId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRouteImport.update(
    {
      id: '/(main)/contract-review/',
      path: '/contract-review/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRouteImport.update(
    {
      id: '/(main)/contract-review/$domain',
      path: '/contract-review/$domain',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRouteImport.update(
    {
      id: '/(main)/legal-deviations/',
      path: '/legal-deviations/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRouteImport.update(
    {
      id: '/(main)/legal-deviations/$domain',
      path: '/legal-deviations/$domain',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRouteImport.update(
    {
      id: '/(main)/scope-breakdown/',
      path: '/scope-breakdown/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRouteImport.update(
    {
      id: '/(main)/standard-deviations/',
      path: '/standard-deviations/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRouteImport.update(
    {
      id: '/(main)/standard-deviations/$deviationId',
      path: '/standard-deviations/$deviationId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRouteImport.update(
    {
      id: '/version-history',
      path: '/version-history',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteImport.update(
    {
      id: '/settings',
      path: '/settings',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRouteImport.update(
    {
      id: '/summary',
      path: '/summary',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRouteImport.update(
    {
      id: '/comparison/',
      path: '/comparison/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRouteImport.update(
    {
      id: '/comparison/$sheetId',
      path: '/comparison/$sheetId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRouteImport.update(
    {
      id: '/change-analysis/',
      path: '/change-analysis/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRouteImport.update(
    {
      id: '/change-analysis/$assessmentId',
      path: '/change-analysis/$assessmentId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRouteImport.update(
    {
      id: '/comparison/',
      path: '/comparison/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRouteImport.update(
    {
      id: '/comparison/$sheetId',
      path: '/comparison/$sheetId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRouteImport.update(
    {
      id: '/files/',
      path: '/files/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRouteImport.update(
    {
      id: '/files/$documentId',
      path: '/files/$documentId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRouteImport.update(
    {
      id: '/disciplines',
      path: '/disciplines',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRouteImport.update(
    {
      id: '/(main)/clauses/$subcategoryId/',
      path: '/clauses/$subcategoryId/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRouteImport.update(
    {
      id: '/(main)/clauses/$subcategoryId/$clauseId',
      path: '/clauses/$subcategoryId/$clauseId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRouteImport.update(
    {
      id: '/compliance/',
      path: '/compliance/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRouteImport.update(
    {
      id: '/cv-analysis/',
      path: '/cv-analysis/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRouteImport.update(
    {
      id: '/cv-analysis/$positionId',
      path: '/cv-analysis/$positionId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRouteImport.update(
    {
      id: '/deliverables/',
      path: '/deliverables/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRouteImport.update(
    {
      id: '/files/',
      path: '/files/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRouteImport.update(
    {
      id: '/files/$documentId',
      path: '/files/$documentId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRouteImport.update(
    {
      id: '/offers/$subcontractorId/',
      path: '/offers/$subcontractorId/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRouteImport.update(
    {
      id: '/compliance/$categoryId/',
      path: '/compliance/$categoryId/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRouteImport.update(
    {
      id: '/compliance/$categoryId/$groupId',
      path: '/compliance/$categoryId/$groupId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRouteImport.update(
    {
      id: '/deliverables/$criterionId/',
      path: '/deliverables/$criterionId/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRouteImport.update(
    {
      id: '/deliverables/$criterionId/$deliverableId',
      path: '/deliverables/$criterionId/$deliverableId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRouteImport.update(
    {
      id: '/offers/$subcontractorId/files/',
      path: '/offers/$subcontractorId/files/',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )
const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRoute =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRouteImport.update(
    {
      id: '/offers/$subcontractorId/files/$documentId',
      path: '/offers/$subcontractorId/files/$documentId',
      getParentRoute: () =>
        AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthedOrganizationIndexRoute
  '/go': typeof AuthedGoRouteRouteWithChildren
  '/settings': typeof AuthedSettingsRouteRouteWithChildren
  '/activate-account': typeof AuthActivateAccountRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/session-ended': typeof AuthSessionEndedRoute
  '/accept-invitation': typeof AuthedAcceptInvitationRoute
  '/add-organization': typeof AuthedAddOrganizationRoute
  '/choose-organization': typeof AuthedChooseOrganizationRoute
  '/p/$token': typeof PTokenRoute
  '/auth/callback': typeof AuthAuthCallbackRoute
  '/auth0/callback': typeof AuthAuth0CallbackRoute
  '/my-tasks': typeof AuthedOrganizationMyTasksRoute
  '/notifications': typeof AuthedOrganizationNotificationsRoute
  '/release-notes': typeof AuthedOrganizationReleaseNotesRoute
  '/project/$projectId': typeof AuthedProjectProjectIdRouteWithChildren
  '/settings/clients': typeof AuthedSettingsClientsRoute
  '/settings/members': typeof AuthedSettingsMembersRoute
  '/settings/organizations': typeof AuthedSettingsOrganizationsRoute
  '/settings/procore': typeof AuthedSettingsProcoreRoute
  '/settings/profile': typeof AuthedSettingsProfileRoute
  '/settings/sharepoint': typeof AuthedSettingsSharepointRoute
  '/settings/sso': typeof AuthedSettingsSsoRoute
  '/settings/suppliers': typeof AuthedSettingsSuppliersRoute
  '/settings/workspaces': typeof AuthedSettingsWorkspacesRoute
  '/project/$projectId/artifacts': typeof AuthedProjectProjectIdArtifactsRouteRouteWithChildren
  '/project/$projectId/settings': typeof AuthedProjectProjectIdSettingsRouteRouteWithChildren
  '/go/$entity/$entityId': typeof AuthedGoEntityEntityIdRoute
  '/go/teams-link/$state': typeof AuthedGoTeamsLinkStateRoute
  '/project/$projectId/insights': typeof AuthedProjectProjectIdInsightsRoute
  '/project/$projectId/members': typeof AuthedProjectProjectIdMembersRoute
  '/project/$projectId/tasks': typeof AuthedProjectProjectIdTasksRoute
  '/settings/internal/curator': typeof AuthedSettingsInternalCuratorRoute
  '/settings/internal/organizations': typeof AuthedSettingsInternalOrganizationsRoute
  '/settings/knowledge-base/new-feedback': typeof AuthedSettingsKnowledgeBaseNewFeedbackRoute
  '/settings/templates/$templateId': typeof AuthedSettingsTemplatesTemplateIdRoute
  '/settings/templates/new': typeof AuthedSettingsTemplatesNewRoute
  '/learnings/': typeof AuthedOrganizationLearningsIndexRoute
  '/project/$projectId/': typeof AuthedProjectProjectIdIndexRoute
  '/settings/knowledge-base/': typeof AuthedSettingsKnowledgeBaseIndexRoute
  '/settings/templates/': typeof AuthedSettingsTemplatesIndexRoute
  '/learnings/clients/$clientId': typeof AuthedOrganizationLearningsClientsClientIdRoute
  '/learnings/portfolio/$projectType': typeof AuthedOrganizationLearningsPortfolioProjectTypeRoute
  '/project/$projectId/artifacts/$artifactId': typeof AuthedProjectProjectIdArtifactsArtifactIdRouteWithChildren
  '/project/$projectId/contracts/$': typeof AuthedProjectProjectIdContractsSplatRoute
  '/project/$projectId/tender-packages/$': typeof AuthedProjectProjectIdTenderPackagesSplatRoute
  '/project/$projectId/workspaces/$workspaceId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdRouteWithChildren
  '/settings/knowledge-base/internal/$knowledgeBaseId': typeof AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRoute
  '/settings/knowledge-base/tender-feedbacks/$tenderFeedbackId': typeof AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRoute
  '/project/$projectId/artifacts/': typeof AuthedProjectProjectIdArtifactsIndexRoute
  '/project/$projectId/settings/': typeof AuthedProjectProjectIdSettingsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/contract-management': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteWithChildren
  '/project/$projectId/artifacts/$artifactId/version-history': typeof AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRoute
  '/project/$projectId/artifacts/$artifactId/': typeof AuthedProjectProjectIdArtifactsArtifactIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/artifacts': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/settings': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/insights': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRoute
  '/project/$projectId/workspaces/$workspaceId/tasks': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/extractions': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRoute
  '/project/$projectId/workspaces/$workspaceId/summary': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRoute
  '/project/$projectId/workspaces/$workspaceId/work-packages': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRoute
  '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRoute
  '/project/$projectId/workspaces/$workspaceId/artifacts/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/files/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/settings/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/settings': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteWithChildren
  '/project/$projectId/workspaces/$workspaceId/ambiguities/$ambiguityId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRoute
  '/project/$projectId/workspaces/$workspaceId/checklists/$runId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRoute
  '/project/$projectId/workspaces/$workspaceId/conflicts/$conflictId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRoute
  '/project/$projectId/workspaces/$workspaceId/contract-review/$domain': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRoute
  '/project/$projectId/workspaces/$workspaceId/legal-deviations/$domain': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRoute
  '/project/$projectId/workspaces/$workspaceId/standard-deviations/$deviationId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRoute
  '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId/version-history': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/summary': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRoute
  '/project/$projectId/workspaces/$workspaceId/bids/comparison/$sheetId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRoute
  '/project/$projectId/workspaces/$workspaceId/ambiguities/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/checklists/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/clauses/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/conflicts/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/contract-review/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRoute
  '/project/$projectId/workspaces/$workspaceId/legal-deviations/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/scope-breakdown/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRoute
  '/project/$projectId/workspaces/$workspaceId/standard-deviations/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/comparison/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId/$clauseId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis/$positionId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRoute
  '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/settings/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId/$groupId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId/$deliverableId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedOrganizationIndexRoute
  '/go': typeof AuthedGoRouteRouteWithChildren
  '/settings': typeof AuthedSettingsRouteRouteWithChildren
  '/activate-account': typeof AuthActivateAccountRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/session-ended': typeof AuthSessionEndedRoute
  '/accept-invitation': typeof AuthedAcceptInvitationRoute
  '/add-organization': typeof AuthedAddOrganizationRoute
  '/choose-organization': typeof AuthedChooseOrganizationRoute
  '/p/$token': typeof PTokenRoute
  '/auth/callback': typeof AuthAuthCallbackRoute
  '/auth0/callback': typeof AuthAuth0CallbackRoute
  '/my-tasks': typeof AuthedOrganizationMyTasksRoute
  '/notifications': typeof AuthedOrganizationNotificationsRoute
  '/release-notes': typeof AuthedOrganizationReleaseNotesRoute
  '/settings/clients': typeof AuthedSettingsClientsRoute
  '/settings/members': typeof AuthedSettingsMembersRoute
  '/settings/organizations': typeof AuthedSettingsOrganizationsRoute
  '/settings/procore': typeof AuthedSettingsProcoreRoute
  '/settings/profile': typeof AuthedSettingsProfileRoute
  '/settings/sharepoint': typeof AuthedSettingsSharepointRoute
  '/settings/sso': typeof AuthedSettingsSsoRoute
  '/settings/suppliers': typeof AuthedSettingsSuppliersRoute
  '/settings/workspaces': typeof AuthedSettingsWorkspacesRoute
  '/go/$entity/$entityId': typeof AuthedGoEntityEntityIdRoute
  '/go/teams-link/$state': typeof AuthedGoTeamsLinkStateRoute
  '/project/$projectId/insights': typeof AuthedProjectProjectIdInsightsRoute
  '/project/$projectId/members': typeof AuthedProjectProjectIdMembersRoute
  '/project/$projectId/tasks': typeof AuthedProjectProjectIdTasksRoute
  '/settings/internal/curator': typeof AuthedSettingsInternalCuratorRoute
  '/settings/internal/organizations': typeof AuthedSettingsInternalOrganizationsRoute
  '/settings/knowledge-base/new-feedback': typeof AuthedSettingsKnowledgeBaseNewFeedbackRoute
  '/settings/templates/$templateId': typeof AuthedSettingsTemplatesTemplateIdRoute
  '/settings/templates/new': typeof AuthedSettingsTemplatesNewRoute
  '/learnings': typeof AuthedOrganizationLearningsIndexRoute
  '/project/$projectId': typeof AuthedProjectProjectIdIndexRoute
  '/settings/knowledge-base': typeof AuthedSettingsKnowledgeBaseIndexRoute
  '/settings/templates': typeof AuthedSettingsTemplatesIndexRoute
  '/learnings/clients/$clientId': typeof AuthedOrganizationLearningsClientsClientIdRoute
  '/learnings/portfolio/$projectType': typeof AuthedOrganizationLearningsPortfolioProjectTypeRoute
  '/project/$projectId/contracts/$': typeof AuthedProjectProjectIdContractsSplatRoute
  '/project/$projectId/tender-packages/$': typeof AuthedProjectProjectIdTenderPackagesSplatRoute
  '/project/$projectId/workspaces/$workspaceId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRoute
  '/settings/knowledge-base/internal/$knowledgeBaseId': typeof AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRoute
  '/settings/knowledge-base/tender-feedbacks/$tenderFeedbackId': typeof AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRoute
  '/project/$projectId/artifacts': typeof AuthedProjectProjectIdArtifactsIndexRoute
  '/project/$projectId/settings': typeof AuthedProjectProjectIdSettingsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteWithChildren
  '/project/$projectId/artifacts/$artifactId/version-history': typeof AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRoute
  '/project/$projectId/artifacts/$artifactId': typeof AuthedProjectProjectIdArtifactsArtifactIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/insights': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRoute
  '/project/$projectId/workspaces/$workspaceId/tasks': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/extractions': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRoute
  '/project/$projectId/workspaces/$workspaceId/summary': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRoute
  '/project/$projectId/workspaces/$workspaceId/work-packages': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRoute
  '/project/$projectId/workspaces/$workspaceId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRoute
  '/project/$projectId/workspaces/$workspaceId/artifacts': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/files': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/settings': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/ambiguities/$ambiguityId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRoute
  '/project/$projectId/workspaces/$workspaceId/checklists/$runId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRoute
  '/project/$projectId/workspaces/$workspaceId/conflicts/$conflictId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRoute
  '/project/$projectId/workspaces/$workspaceId/contract-review/$domain': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRoute
  '/project/$projectId/workspaces/$workspaceId/legal-deviations/$domain': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRoute
  '/project/$projectId/workspaces/$workspaceId/standard-deviations/$deviationId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRoute
  '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId/version-history': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/summary': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRoute
  '/project/$projectId/workspaces/$workspaceId/bids/comparison/$sheetId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRoute
  '/project/$projectId/workspaces/$workspaceId/ambiguities': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/checklists': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/clauses': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/conflicts': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/contract-review': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRoute
  '/project/$projectId/workspaces/$workspaceId/legal-deviations': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/scope-breakdown': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRoute
  '/project/$projectId/workspaces/$workspaceId/standard-deviations': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/comparison': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRoute
  '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId/$clauseId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis/$positionId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRoute
  '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/settings': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId/$groupId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId/$deliverableId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRoute
  '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_authed': typeof AuthedRouteWithChildren
  '/_authed/_organization': typeof AuthedOrganizationRouteRouteWithChildren
  '/_authed/go': typeof AuthedGoRouteRouteWithChildren
  '/_authed/settings': typeof AuthedSettingsRouteRouteWithChildren
  '/_auth/activate-account': typeof AuthActivateAccountRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/session-ended': typeof AuthSessionEndedRoute
  '/_authed/accept-invitation': typeof AuthedAcceptInvitationRoute
  '/_authed/add-organization': typeof AuthedAddOrganizationRoute
  '/_authed/choose-organization': typeof AuthedChooseOrganizationRoute
  '/p/$token': typeof PTokenRoute
  '/_auth/auth/callback': typeof AuthAuthCallbackRoute
  '/_auth/auth0/callback': typeof AuthAuth0CallbackRoute
  '/_authed/_organization/my-tasks': typeof AuthedOrganizationMyTasksRoute
  '/_authed/_organization/notifications': typeof AuthedOrganizationNotificationsRoute
  '/_authed/_organization/release-notes': typeof AuthedOrganizationReleaseNotesRoute
  '/_authed/project/$projectId': typeof AuthedProjectProjectIdRouteWithChildren
  '/_authed/settings/clients': typeof AuthedSettingsClientsRoute
  '/_authed/settings/members': typeof AuthedSettingsMembersRoute
  '/_authed/settings/organizations': typeof AuthedSettingsOrganizationsRoute
  '/_authed/settings/procore': typeof AuthedSettingsProcoreRoute
  '/_authed/settings/profile': typeof AuthedSettingsProfileRoute
  '/_authed/settings/sharepoint': typeof AuthedSettingsSharepointRoute
  '/_authed/settings/sso': typeof AuthedSettingsSsoRoute
  '/_authed/settings/suppliers': typeof AuthedSettingsSuppliersRoute
  '/_authed/settings/workspaces': typeof AuthedSettingsWorkspacesRoute
  '/_authed/_organization/': typeof AuthedOrganizationIndexRoute
  '/_authed/project/$projectId/artifacts': typeof AuthedProjectProjectIdArtifactsRouteRouteWithChildren
  '/_authed/project/$projectId/settings': typeof AuthedProjectProjectIdSettingsRouteRouteWithChildren
  '/_authed/go/$entity/$entityId': typeof AuthedGoEntityEntityIdRoute
  '/_authed/go/teams-link/$state': typeof AuthedGoTeamsLinkStateRoute
  '/_authed/project/$projectId/insights': typeof AuthedProjectProjectIdInsightsRoute
  '/_authed/project/$projectId/members': typeof AuthedProjectProjectIdMembersRoute
  '/_authed/project/$projectId/tasks': typeof AuthedProjectProjectIdTasksRoute
  '/_authed/settings/internal/curator': typeof AuthedSettingsInternalCuratorRoute
  '/_authed/settings/internal/organizations': typeof AuthedSettingsInternalOrganizationsRoute
  '/_authed/settings/knowledge-base/new-feedback': typeof AuthedSettingsKnowledgeBaseNewFeedbackRoute
  '/_authed/settings/templates/$templateId': typeof AuthedSettingsTemplatesTemplateIdRoute
  '/_authed/settings/templates/new': typeof AuthedSettingsTemplatesNewRoute
  '/_authed/_organization/learnings/': typeof AuthedOrganizationLearningsIndexRoute
  '/_authed/project/$projectId/': typeof AuthedProjectProjectIdIndexRoute
  '/_authed/settings/knowledge-base/': typeof AuthedSettingsKnowledgeBaseIndexRoute
  '/_authed/settings/templates/': typeof AuthedSettingsTemplatesIndexRoute
  '/_authed/_organization/learnings/clients/$clientId': typeof AuthedOrganizationLearningsClientsClientIdRoute
  '/_authed/_organization/learnings/portfolio/$projectType': typeof AuthedOrganizationLearningsPortfolioProjectTypeRoute
  '/_authed/project/$projectId/artifacts/$artifactId': typeof AuthedProjectProjectIdArtifactsArtifactIdRouteWithChildren
  '/_authed/project/$projectId/contracts/$': typeof AuthedProjectProjectIdContractsSplatRoute
  '/_authed/project/$projectId/tender-packages/$': typeof AuthedProjectProjectIdTenderPackagesSplatRoute
  '/_authed/project/$projectId/workspaces/$workspaceId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdRouteWithChildren
  '/_authed/settings/knowledge-base/internal/$knowledgeBaseId': typeof AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRoute
  '/_authed/settings/knowledge-base/tender-feedbacks/$tenderFeedbackId': typeof AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRoute
  '/_authed/project/$projectId/artifacts/': typeof AuthedProjectProjectIdArtifactsIndexRoute
  '/_authed/project/$projectId/settings/': typeof AuthedProjectProjectIdSettingsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/contract-management': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteWithChildren
  '/_authed/project/$projectId/artifacts/$artifactId/version-history': typeof AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteWithChildren
  '/_authed/project/$projectId/artifacts/$artifactId/': typeof AuthedProjectProjectIdArtifactsArtifactIdIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/insights': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/tasks': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/extractions': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/summary': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/work-packages': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteWithChildren
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/$ambiguityId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/$runId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/$conflictId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/$domain': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/$domain': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/$deviationId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId/version-history': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/summary': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/$sheetId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/scope-breakdown/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/$clauseId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/$positionId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/$groupId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/$deliverableId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRoute
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/': typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/go'
    | '/settings'
    | '/activate-account'
    | '/login'
    | '/register'
    | '/session-ended'
    | '/accept-invitation'
    | '/add-organization'
    | '/choose-organization'
    | '/p/$token'
    | '/auth/callback'
    | '/auth0/callback'
    | '/my-tasks'
    | '/notifications'
    | '/release-notes'
    | '/project/$projectId'
    | '/settings/clients'
    | '/settings/members'
    | '/settings/organizations'
    | '/settings/procore'
    | '/settings/profile'
    | '/settings/sharepoint'
    | '/settings/sso'
    | '/settings/suppliers'
    | '/settings/workspaces'
    | '/project/$projectId/artifacts'
    | '/project/$projectId/settings'
    | '/go/$entity/$entityId'
    | '/go/teams-link/$state'
    | '/project/$projectId/insights'
    | '/project/$projectId/members'
    | '/project/$projectId/tasks'
    | '/settings/internal/curator'
    | '/settings/internal/organizations'
    | '/settings/knowledge-base/new-feedback'
    | '/settings/templates/$templateId'
    | '/settings/templates/new'
    | '/learnings/'
    | '/project/$projectId/'
    | '/settings/knowledge-base/'
    | '/settings/templates/'
    | '/learnings/clients/$clientId'
    | '/learnings/portfolio/$projectType'
    | '/project/$projectId/artifacts/$artifactId'
    | '/project/$projectId/contracts/$'
    | '/project/$projectId/tender-packages/$'
    | '/project/$projectId/workspaces/$workspaceId'
    | '/settings/knowledge-base/internal/$knowledgeBaseId'
    | '/settings/knowledge-base/tender-feedbacks/$tenderFeedbackId'
    | '/project/$projectId/artifacts/'
    | '/project/$projectId/settings/'
    | '/project/$projectId/workspaces/$workspaceId/bids'
    | '/project/$projectId/workspaces/$workspaceId/contract-management'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids'
    | '/project/$projectId/artifacts/$artifactId/version-history'
    | '/project/$projectId/artifacts/$artifactId/'
    | '/project/$projectId/workspaces/$workspaceId/artifacts'
    | '/project/$projectId/workspaces/$workspaceId/settings'
    | '/project/$projectId/workspaces/$workspaceId/insights'
    | '/project/$projectId/workspaces/$workspaceId/tasks'
    | '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId'
    | '/project/$projectId/workspaces/$workspaceId/'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings'
    | '/project/$projectId/workspaces/$workspaceId/extractions'
    | '/project/$projectId/workspaces/$workspaceId/summary'
    | '/project/$projectId/workspaces/$workspaceId/work-packages'
    | '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId'
    | '/project/$projectId/workspaces/$workspaceId/files/$documentId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology'
    | '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work'
    | '/project/$projectId/workspaces/$workspaceId/artifacts/'
    | '/project/$projectId/workspaces/$workspaceId/files/'
    | '/project/$projectId/workspaces/$workspaceId/settings/'
    | '/project/$projectId/workspaces/$workspaceId/bids/'
    | '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/settings'
    | '/project/$projectId/workspaces/$workspaceId/ambiguities/$ambiguityId'
    | '/project/$projectId/workspaces/$workspaceId/checklists/$runId'
    | '/project/$projectId/workspaces/$workspaceId/conflicts/$conflictId'
    | '/project/$projectId/workspaces/$workspaceId/contract-review/$domain'
    | '/project/$projectId/workspaces/$workspaceId/legal-deviations/$domain'
    | '/project/$projectId/workspaces/$workspaceId/standard-deviations/$deviationId'
    | '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId/version-history'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/summary'
    | '/project/$projectId/workspaces/$workspaceId/bids/comparison/$sheetId'
    | '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines'
    | '/project/$projectId/workspaces/$workspaceId/ambiguities/'
    | '/project/$projectId/workspaces/$workspaceId/checklists/'
    | '/project/$projectId/workspaces/$workspaceId/clauses/'
    | '/project/$projectId/workspaces/$workspaceId/conflicts/'
    | '/project/$projectId/workspaces/$workspaceId/contract-review/'
    | '/project/$projectId/workspaces/$workspaceId/legal-deviations/'
    | '/project/$projectId/workspaces/$workspaceId/scope-breakdown/'
    | '/project/$projectId/workspaces/$workspaceId/standard-deviations/'
    | '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId/'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/'
    | '/project/$projectId/workspaces/$workspaceId/bids/comparison/'
    | '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/'
    | '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId/$clauseId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis/$positionId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files/$documentId'
    | '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId/'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis/'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files/'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/settings/'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId/$groupId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId/$deliverableId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId/'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId/'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/go'
    | '/settings'
    | '/activate-account'
    | '/login'
    | '/register'
    | '/session-ended'
    | '/accept-invitation'
    | '/add-organization'
    | '/choose-organization'
    | '/p/$token'
    | '/auth/callback'
    | '/auth0/callback'
    | '/my-tasks'
    | '/notifications'
    | '/release-notes'
    | '/settings/clients'
    | '/settings/members'
    | '/settings/organizations'
    | '/settings/procore'
    | '/settings/profile'
    | '/settings/sharepoint'
    | '/settings/sso'
    | '/settings/suppliers'
    | '/settings/workspaces'
    | '/go/$entity/$entityId'
    | '/go/teams-link/$state'
    | '/project/$projectId/insights'
    | '/project/$projectId/members'
    | '/project/$projectId/tasks'
    | '/settings/internal/curator'
    | '/settings/internal/organizations'
    | '/settings/knowledge-base/new-feedback'
    | '/settings/templates/$templateId'
    | '/settings/templates/new'
    | '/learnings'
    | '/project/$projectId'
    | '/settings/knowledge-base'
    | '/settings/templates'
    | '/learnings/clients/$clientId'
    | '/learnings/portfolio/$projectType'
    | '/project/$projectId/contracts/$'
    | '/project/$projectId/tender-packages/$'
    | '/project/$projectId/workspaces/$workspaceId'
    | '/settings/knowledge-base/internal/$knowledgeBaseId'
    | '/settings/knowledge-base/tender-feedbacks/$tenderFeedbackId'
    | '/project/$projectId/artifacts'
    | '/project/$projectId/settings'
    | '/project/$projectId/workspaces/$workspaceId/bids'
    | '/project/$projectId/workspaces/$workspaceId/contract-management'
    | '/project/$projectId/artifacts/$artifactId/version-history'
    | '/project/$projectId/artifacts/$artifactId'
    | '/project/$projectId/workspaces/$workspaceId/insights'
    | '/project/$projectId/workspaces/$workspaceId/tasks'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids'
    | '/project/$projectId/workspaces/$workspaceId/extractions'
    | '/project/$projectId/workspaces/$workspaceId/summary'
    | '/project/$projectId/workspaces/$workspaceId/work-packages'
    | '/project/$projectId/workspaces/$workspaceId/files/$documentId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology'
    | '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work'
    | '/project/$projectId/workspaces/$workspaceId/artifacts'
    | '/project/$projectId/workspaces/$workspaceId/files'
    | '/project/$projectId/workspaces/$workspaceId/settings'
    | '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId'
    | '/project/$projectId/workspaces/$workspaceId/ambiguities/$ambiguityId'
    | '/project/$projectId/workspaces/$workspaceId/checklists/$runId'
    | '/project/$projectId/workspaces/$workspaceId/conflicts/$conflictId'
    | '/project/$projectId/workspaces/$workspaceId/contract-review/$domain'
    | '/project/$projectId/workspaces/$workspaceId/legal-deviations/$domain'
    | '/project/$projectId/workspaces/$workspaceId/standard-deviations/$deviationId'
    | '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId/version-history'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/summary'
    | '/project/$projectId/workspaces/$workspaceId/bids/comparison/$sheetId'
    | '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines'
    | '/project/$projectId/workspaces/$workspaceId/ambiguities'
    | '/project/$projectId/workspaces/$workspaceId/checklists'
    | '/project/$projectId/workspaces/$workspaceId/clauses'
    | '/project/$projectId/workspaces/$workspaceId/conflicts'
    | '/project/$projectId/workspaces/$workspaceId/contract-review'
    | '/project/$projectId/workspaces/$workspaceId/legal-deviations'
    | '/project/$projectId/workspaces/$workspaceId/scope-breakdown'
    | '/project/$projectId/workspaces/$workspaceId/standard-deviations'
    | '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId'
    | '/project/$projectId/workspaces/$workspaceId/bids/comparison'
    | '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings'
    | '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId/$clauseId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis/$positionId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files/$documentId'
    | '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/settings'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId/$groupId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId/$deliverableId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId'
    | '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId'
    | '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files'
  id:
    | '__root__'
    | '/_auth'
    | '/_authed'
    | '/_authed/_organization'
    | '/_authed/go'
    | '/_authed/settings'
    | '/_auth/activate-account'
    | '/_auth/login'
    | '/_auth/register'
    | '/_auth/session-ended'
    | '/_authed/accept-invitation'
    | '/_authed/add-organization'
    | '/_authed/choose-organization'
    | '/p/$token'
    | '/_auth/auth/callback'
    | '/_auth/auth0/callback'
    | '/_authed/_organization/my-tasks'
    | '/_authed/_organization/notifications'
    | '/_authed/_organization/release-notes'
    | '/_authed/project/$projectId'
    | '/_authed/settings/clients'
    | '/_authed/settings/members'
    | '/_authed/settings/organizations'
    | '/_authed/settings/procore'
    | '/_authed/settings/profile'
    | '/_authed/settings/sharepoint'
    | '/_authed/settings/sso'
    | '/_authed/settings/suppliers'
    | '/_authed/settings/workspaces'
    | '/_authed/_organization/'
    | '/_authed/project/$projectId/artifacts'
    | '/_authed/project/$projectId/settings'
    | '/_authed/go/$entity/$entityId'
    | '/_authed/go/teams-link/$state'
    | '/_authed/project/$projectId/insights'
    | '/_authed/project/$projectId/members'
    | '/_authed/project/$projectId/tasks'
    | '/_authed/settings/internal/curator'
    | '/_authed/settings/internal/organizations'
    | '/_authed/settings/knowledge-base/new-feedback'
    | '/_authed/settings/templates/$templateId'
    | '/_authed/settings/templates/new'
    | '/_authed/_organization/learnings/'
    | '/_authed/project/$projectId/'
    | '/_authed/settings/knowledge-base/'
    | '/_authed/settings/templates/'
    | '/_authed/_organization/learnings/clients/$clientId'
    | '/_authed/_organization/learnings/portfolio/$projectType'
    | '/_authed/project/$projectId/artifacts/$artifactId'
    | '/_authed/project/$projectId/contracts/$'
    | '/_authed/project/$projectId/tender-packages/$'
    | '/_authed/project/$projectId/workspaces/$workspaceId'
    | '/_authed/settings/knowledge-base/internal/$knowledgeBaseId'
    | '/_authed/settings/knowledge-base/tender-feedbacks/$tenderFeedbackId'
    | '/_authed/project/$projectId/artifacts/'
    | '/_authed/project/$projectId/settings/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids'
    | '/_authed/project/$projectId/workspaces/$workspaceId/contract-management'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids'
    | '/_authed/project/$projectId/artifacts/$artifactId/version-history'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout'
    | '/_authed/project/$projectId/artifacts/$artifactId/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/insights'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/tasks'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout'
    | '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/extractions'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/summary'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/work-packages'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/$documentId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology'
    | '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/$ambiguityId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/$runId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/$conflictId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/$domain'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/$domain'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/$deviationId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId/version-history'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/summary'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/$sheetId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/scope-breakdown/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/$clauseId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/$positionId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/$documentId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/$groupId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/$deliverableId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/'
    | '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthedRoute: typeof AuthedRouteWithChildren
  PTokenRoute: typeof PTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/activate-account': {
      id: '/_auth/activate-account'
      path: '/activate-account'
      fullPath: '/activate-account'
      preLoaderRoute: typeof AuthActivateAccountRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/session-ended': {
      id: '/_auth/session-ended'
      path: '/session-ended'
      fullPath: '/session-ended'
      preLoaderRoute: typeof AuthSessionEndedRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authed/_organization': {
      id: '/_authed/_organization'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedOrganizationRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/accept-invitation': {
      id: '/_authed/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AuthedAcceptInvitationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/add-organization': {
      id: '/_authed/add-organization'
      path: '/add-organization'
      fullPath: '/add-organization'
      preLoaderRoute: typeof AuthedAddOrganizationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/choose-organization': {
      id: '/_authed/choose-organization'
      path: '/choose-organization'
      fullPath: '/choose-organization'
      preLoaderRoute: typeof AuthedChooseOrganizationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/go': {
      id: '/_authed/go'
      path: '/go'
      fullPath: '/go'
      preLoaderRoute: typeof AuthedGoRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/p/$token': {
      id: '/p/$token'
      path: '/p/$token'
      fullPath: '/p/$token'
      preLoaderRoute: typeof PTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/auth/callback': {
      id: '/_auth/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthAuthCallbackRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/auth0/callback': {
      id: '/_auth/auth0/callback'
      path: '/auth0/callback'
      fullPath: '/auth0/callback'
      preLoaderRoute: typeof AuthAuth0CallbackRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authed/_organization/': {
      id: '/_authed/_organization/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedOrganizationIndexRouteImport
      parentRoute: typeof AuthedOrganizationRouteRoute
    }
    '/_authed/_organization/my-tasks': {
      id: '/_authed/_organization/my-tasks'
      path: '/my-tasks'
      fullPath: '/my-tasks'
      preLoaderRoute: typeof AuthedOrganizationMyTasksRouteImport
      parentRoute: typeof AuthedOrganizationRouteRoute
    }
    '/_authed/_organization/notifications': {
      id: '/_authed/_organization/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthedOrganizationNotificationsRouteImport
      parentRoute: typeof AuthedOrganizationRouteRoute
    }
    '/_authed/_organization/release-notes': {
      id: '/_authed/_organization/release-notes'
      path: '/release-notes'
      fullPath: '/release-notes'
      preLoaderRoute: typeof AuthedOrganizationReleaseNotesRouteImport
      parentRoute: typeof AuthedOrganizationRouteRoute
    }
    '/_authed/project/$projectId': {
      id: '/_authed/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof AuthedProjectProjectIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/clients': {
      id: '/_authed/settings/clients'
      path: '/clients'
      fullPath: '/settings/clients'
      preLoaderRoute: typeof AuthedSettingsClientsRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/members': {
      id: '/_authed/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthedSettingsMembersRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/organizations': {
      id: '/_authed/settings/organizations'
      path: '/organizations'
      fullPath: '/settings/organizations'
      preLoaderRoute: typeof AuthedSettingsOrganizationsRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/procore': {
      id: '/_authed/settings/procore'
      path: '/procore'
      fullPath: '/settings/procore'
      preLoaderRoute: typeof AuthedSettingsProcoreRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/profile': {
      id: '/_authed/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthedSettingsProfileRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/sharepoint': {
      id: '/_authed/settings/sharepoint'
      path: '/sharepoint'
      fullPath: '/settings/sharepoint'
      preLoaderRoute: typeof AuthedSettingsSharepointRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/sso': {
      id: '/_authed/settings/sso'
      path: '/sso'
      fullPath: '/settings/sso'
      preLoaderRoute: typeof AuthedSettingsSsoRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/suppliers': {
      id: '/_authed/settings/suppliers'
      path: '/suppliers'
      fullPath: '/settings/suppliers'
      preLoaderRoute: typeof AuthedSettingsSuppliersRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/workspaces': {
      id: '/_authed/settings/workspaces'
      path: '/workspaces'
      fullPath: '/settings/workspaces'
      preLoaderRoute: typeof AuthedSettingsWorkspacesRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/_organization/learnings/': {
      id: '/_authed/_organization/learnings/'
      path: '/learnings'
      fullPath: '/learnings/'
      preLoaderRoute: typeof AuthedOrganizationLearningsIndexRouteImport
      parentRoute: typeof AuthedOrganizationRouteRoute
    }
    '/_authed/go/$entity/$entityId': {
      id: '/_authed/go/$entity/$entityId'
      path: '/$entity/$entityId'
      fullPath: '/go/$entity/$entityId'
      preLoaderRoute: typeof AuthedGoEntityEntityIdRouteImport
      parentRoute: typeof AuthedGoRouteRoute
    }
    '/_authed/go/teams-link/$state': {
      id: '/_authed/go/teams-link/$state'
      path: '/teams-link/$state'
      fullPath: '/go/teams-link/$state'
      preLoaderRoute: typeof AuthedGoTeamsLinkStateRouteImport
      parentRoute: typeof AuthedGoRouteRoute
    }
    '/_authed/project/$projectId/': {
      id: '/_authed/project/$projectId/'
      path: '/'
      fullPath: '/project/$projectId/'
      preLoaderRoute: typeof AuthedProjectProjectIdIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdRoute
    }
    '/_authed/project/$projectId/artifacts': {
      id: '/_authed/project/$projectId/artifacts'
      path: '/artifacts'
      fullPath: '/project/$projectId/artifacts'
      preLoaderRoute: typeof AuthedProjectProjectIdArtifactsRouteRouteImport
      parentRoute: typeof AuthedProjectProjectIdRoute
    }
    '/_authed/project/$projectId/insights': {
      id: '/_authed/project/$projectId/insights'
      path: '/insights'
      fullPath: '/project/$projectId/insights'
      preLoaderRoute: typeof AuthedProjectProjectIdInsightsRouteImport
      parentRoute: typeof AuthedProjectProjectIdRoute
    }
    '/_authed/project/$projectId/members': {
      id: '/_authed/project/$projectId/members'
      path: '/members'
      fullPath: '/project/$projectId/members'
      preLoaderRoute: typeof AuthedProjectProjectIdMembersRouteImport
      parentRoute: typeof AuthedProjectProjectIdRoute
    }
    '/_authed/project/$projectId/settings': {
      id: '/_authed/project/$projectId/settings'
      path: '/settings'
      fullPath: '/project/$projectId/settings'
      preLoaderRoute: typeof AuthedProjectProjectIdSettingsRouteRouteImport
      parentRoute: typeof AuthedProjectProjectIdRoute
    }
    '/_authed/project/$projectId/tasks': {
      id: '/_authed/project/$projectId/tasks'
      path: '/tasks'
      fullPath: '/project/$projectId/tasks'
      preLoaderRoute: typeof AuthedProjectProjectIdTasksRouteImport
      parentRoute: typeof AuthedProjectProjectIdRoute
    }
    '/_authed/settings/internal/curator': {
      id: '/_authed/settings/internal/curator'
      path: '/internal/curator'
      fullPath: '/settings/internal/curator'
      preLoaderRoute: typeof AuthedSettingsInternalCuratorRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/internal/organizations': {
      id: '/_authed/settings/internal/organizations'
      path: '/internal/organizations'
      fullPath: '/settings/internal/organizations'
      preLoaderRoute: typeof AuthedSettingsInternalOrganizationsRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/knowledge-base/': {
      id: '/_authed/settings/knowledge-base/'
      path: '/knowledge-base'
      fullPath: '/settings/knowledge-base/'
      preLoaderRoute: typeof AuthedSettingsKnowledgeBaseIndexRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/knowledge-base/new-feedback': {
      id: '/_authed/settings/knowledge-base/new-feedback'
      path: '/knowledge-base/new-feedback'
      fullPath: '/settings/knowledge-base/new-feedback'
      preLoaderRoute: typeof AuthedSettingsKnowledgeBaseNewFeedbackRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/templates/': {
      id: '/_authed/settings/templates/'
      path: '/templates'
      fullPath: '/settings/templates/'
      preLoaderRoute: typeof AuthedSettingsTemplatesIndexRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/templates/$templateId': {
      id: '/_authed/settings/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/settings/templates/$templateId'
      preLoaderRoute: typeof AuthedSettingsTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/templates/new': {
      id: '/_authed/settings/templates/new'
      path: '/templates/new'
      fullPath: '/settings/templates/new'
      preLoaderRoute: typeof AuthedSettingsTemplatesNewRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/_organization/learnings/clients/$clientId': {
      id: '/_authed/_organization/learnings/clients/$clientId'
      path: '/learnings/clients/$clientId'
      fullPath: '/learnings/clients/$clientId'
      preLoaderRoute: typeof AuthedOrganizationLearningsClientsClientIdRouteImport
      parentRoute: typeof AuthedOrganizationRouteRoute
    }
    '/_authed/_organization/learnings/portfolio/$projectType': {
      id: '/_authed/_organization/learnings/portfolio/$projectType'
      path: '/learnings/portfolio/$projectType'
      fullPath: '/learnings/portfolio/$projectType'
      preLoaderRoute: typeof AuthedOrganizationLearningsPortfolioProjectTypeRouteImport
      parentRoute: typeof AuthedOrganizationRouteRoute
    }
    '/_authed/project/$projectId/artifacts/': {
      id: '/_authed/project/$projectId/artifacts/'
      path: '/'
      fullPath: '/project/$projectId/artifacts/'
      preLoaderRoute: typeof AuthedProjectProjectIdArtifactsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdArtifactsRouteRoute
    }
    '/_authed/project/$projectId/artifacts/$artifactId': {
      id: '/_authed/project/$projectId/artifacts/$artifactId'
      path: '/$artifactId'
      fullPath: '/project/$projectId/artifacts/$artifactId'
      preLoaderRoute: typeof AuthedProjectProjectIdArtifactsArtifactIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdArtifactsRouteRoute
    }
    '/_authed/project/$projectId/contracts/$': {
      id: '/_authed/project/$projectId/contracts/$'
      path: '/contracts/$'
      fullPath: '/project/$projectId/contracts/$'
      preLoaderRoute: typeof AuthedProjectProjectIdContractsSplatRouteImport
      parentRoute: typeof AuthedProjectProjectIdRoute
    }
    '/_authed/project/$projectId/settings/': {
      id: '/_authed/project/$projectId/settings/'
      path: '/'
      fullPath: '/project/$projectId/settings/'
      preLoaderRoute: typeof AuthedProjectProjectIdSettingsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdSettingsRouteRoute
    }
    '/_authed/project/$projectId/tender-packages/$': {
      id: '/_authed/project/$projectId/tender-packages/$'
      path: '/tender-packages/$'
      fullPath: '/project/$projectId/tender-packages/$'
      preLoaderRoute: typeof AuthedProjectProjectIdTenderPackagesSplatRouteImport
      parentRoute: typeof AuthedProjectProjectIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/project/$projectId/workspaces/$workspaceId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdRoute
    }
    '/_authed/settings/knowledge-base/internal/$knowledgeBaseId': {
      id: '/_authed/settings/knowledge-base/internal/$knowledgeBaseId'
      path: '/knowledge-base/internal/$knowledgeBaseId'
      fullPath: '/settings/knowledge-base/internal/$knowledgeBaseId'
      preLoaderRoute: typeof AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/settings/knowledge-base/tender-feedbacks/$tenderFeedbackId': {
      id: '/_authed/settings/knowledge-base/tender-feedbacks/$tenderFeedbackId'
      path: '/knowledge-base/tender-feedbacks/$tenderFeedbackId'
      fullPath: '/settings/knowledge-base/tender-feedbacks/$tenderFeedbackId'
      preLoaderRoute: typeof AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRouteImport
      parentRoute: typeof AuthedSettingsRouteRoute
    }
    '/_authed/project/$projectId/artifacts/$artifactId/': {
      id: '/_authed/project/$projectId/artifacts/$artifactId/'
      path: '/'
      fullPath: '/project/$projectId/artifacts/$artifactId/'
      preLoaderRoute: typeof AuthedProjectProjectIdArtifactsArtifactIdIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdArtifactsArtifactIdRoute
    }
    '/_authed/project/$projectId/artifacts/$artifactId/version-history': {
      id: '/_authed/project/$projectId/artifacts/$artifactId/version-history'
      path: '/version-history'
      fullPath: '/project/$projectId/artifacts/$artifactId/version-history'
      preLoaderRoute: typeof AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRouteImport
      parentRoute: typeof AuthedProjectProjectIdArtifactsArtifactIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout'
      path: ''
      fullPath: '/project/$projectId/workspaces/$workspaceId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids'
      path: '/bids'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/contract-management': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/contract-management'
      path: '/contract-management'
      fullPath: '/project/$projectId/workspaces/$workspaceId/contract-management'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids'
      path: '/subcontractor-bids'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts'
      path: '/artifacts'
      fullPath: '/project/$projectId/workspaces/$workspaceId/artifacts'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/insights': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/insights'
      path: '/insights'
      fullPath: '/project/$projectId/workspaces/$workspaceId/insights'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings'
      path: '/settings'
      fullPath: '/project/$projectId/workspaces/$workspaceId/settings'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/tasks': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/tasks'
      path: '/tasks'
      fullPath: '/project/$projectId/workspaces/$workspaceId/tasks'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout'
      path: ''
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId'
      path: '/$supplementId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId'
      path: '/$procurementId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/extractions': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/extractions'
      path: '/extractions'
      fullPath: '/project/$projectId/workspaces/$workspaceId/extractions'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/summary': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/summary'
      path: '/summary'
      fullPath: '/project/$projectId/workspaces/$workspaceId/summary'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/work-packages': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/work-packages'
      path: '/work-packages'
      fullPath: '/project/$projectId/workspaces/$workspaceId/work-packages'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/artifacts/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId'
      path: '/$artifactId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/'
      path: '/files'
      fullPath: '/project/$projectId/workspaces/$workspaceId/files/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/$documentId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/files/$documentId'
      path: '/files/$documentId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/files/$documentId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/settings/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout'
      path: '/$bidId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft'
      path: '/$bidId/draft'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/draft'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology'
      path: '/$bidId/methodology'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/methodology'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files'
      path: '/files'
      fullPath: '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/files'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling'
      path: '/leveling'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/leveling'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations'
      path: '/reservations'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/reservations'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work'
      path: '/scope-of-work'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/scope-of-work'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings'
      path: '/settings'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/'
      path: '/ambiguities'
      fullPath: '/project/$projectId/workspaces/$workspaceId/ambiguities/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/$ambiguityId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/ambiguities/$ambiguityId'
      path: '/ambiguities/$ambiguityId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/ambiguities/$ambiguityId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/'
      path: '/checklists'
      fullPath: '/project/$projectId/workspaces/$workspaceId/checklists/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/$runId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/checklists/$runId'
      path: '/checklists/$runId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/checklists/$runId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/'
      path: '/clauses'
      fullPath: '/project/$projectId/workspaces/$workspaceId/clauses/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/'
      path: '/conflicts'
      fullPath: '/project/$projectId/workspaces/$workspaceId/conflicts/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/$conflictId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/conflicts/$conflictId'
      path: '/conflicts/$conflictId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/conflicts/$conflictId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/'
      path: '/contract-review'
      fullPath: '/project/$projectId/workspaces/$workspaceId/contract-review/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/$domain': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/contract-review/$domain'
      path: '/contract-review/$domain'
      fullPath: '/project/$projectId/workspaces/$workspaceId/contract-review/$domain'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/'
      path: '/legal-deviations'
      fullPath: '/project/$projectId/workspaces/$workspaceId/legal-deviations/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/$domain': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/legal-deviations/$domain'
      path: '/legal-deviations/$domain'
      fullPath: '/project/$projectId/workspaces/$workspaceId/legal-deviations/$domain'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/scope-breakdown/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/scope-breakdown/'
      path: '/scope-breakdown'
      fullPath: '/project/$projectId/workspaces/$workspaceId/scope-breakdown/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/'
      path: '/standard-deviations'
      fullPath: '/project/$projectId/workspaces/$workspaceId/standard-deviations/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/$deviationId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/standard-deviations/$deviationId'
      path: '/standard-deviations/$deviationId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/standard-deviations/$deviationId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId/version-history': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/artifacts/$artifactId/version-history'
      path: '/version-history'
      fullPath: '/project/$projectId/workspaces/$workspaceId/artifacts/$artifactId/version-history'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings'
      path: '/settings'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/settings'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/summary': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/summary'
      path: '/summary'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/summary'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/'
      path: '/comparison'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/comparison/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/$sheetId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/_layout/comparison/$sheetId'
      path: '/comparison/$sheetId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/comparison/$sheetId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/'
      path: '/change-analysis'
      fullPath: '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId'
      path: '/change-analysis/$assessmentId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/contract-management/$supplementId/change-analysis/$assessmentId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/'
      path: '/comparison'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId'
      path: '/comparison/$sheetId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/comparison/$sheetId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/'
      path: '/files'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId'
      path: '/files/$documentId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/files/$documentId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines'
      path: '/disciplines'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/'
      path: '/clauses/$subcategoryId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/$clauseId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/$clauseId'
      path: '/clauses/$subcategoryId/$clauseId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId/$clauseId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/'
      path: '/compliance'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/'
      path: '/cv-analysis'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/$positionId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/cv-analysis/$positionId'
      path: '/cv-analysis/$positionId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/cv-analysis/$positionId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/'
      path: '/deliverables'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/'
      path: '/files'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/$documentId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/$documentId'
      path: '/files/$documentId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files/$documentId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/settings/'
      path: '/'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/settings/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/'
      path: '/offers/$subcontractorId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/'
      path: '/compliance/$categoryId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/$groupId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/compliance/$categoryId/$groupId'
      path: '/compliance/$categoryId/$groupId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/compliance/$categoryId/$groupId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/'
      path: '/deliverables/$criterionId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/$deliverableId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/deliverables/$criterionId/$deliverableId'
      path: '/deliverables/$criterionId/$deliverableId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/deliverables/$criterionId/$deliverableId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/'
      path: '/offers/$subcontractorId/files'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
    '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId': {
      id: '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId'
      path: '/offers/$subcontractorId/files/$documentId'
      fullPath: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId'
      preLoaderRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRouteImport
      parentRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthActivateAccountRoute: typeof AuthActivateAccountRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthSessionEndedRoute: typeof AuthSessionEndedRoute
  AuthAuthCallbackRoute: typeof AuthAuthCallbackRoute
  AuthAuth0CallbackRoute: typeof AuthAuth0CallbackRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthActivateAccountRoute: AuthActivateAccountRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthSessionEndedRoute: AuthSessionEndedRoute,
  AuthAuthCallbackRoute: AuthAuthCallbackRoute,
  AuthAuth0CallbackRoute: AuthAuth0CallbackRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthedOrganizationRouteRouteChildren {
  AuthedOrganizationMyTasksRoute: typeof AuthedOrganizationMyTasksRoute
  AuthedOrganizationNotificationsRoute: typeof AuthedOrganizationNotificationsRoute
  AuthedOrganizationReleaseNotesRoute: typeof AuthedOrganizationReleaseNotesRoute
  AuthedOrganizationIndexRoute: typeof AuthedOrganizationIndexRoute
  AuthedOrganizationLearningsIndexRoute: typeof AuthedOrganizationLearningsIndexRoute
  AuthedOrganizationLearningsClientsClientIdRoute: typeof AuthedOrganizationLearningsClientsClientIdRoute
  AuthedOrganizationLearningsPortfolioProjectTypeRoute: typeof AuthedOrganizationLearningsPortfolioProjectTypeRoute
}

const AuthedOrganizationRouteRouteChildren: AuthedOrganizationRouteRouteChildren =
  {
    AuthedOrganizationMyTasksRoute: AuthedOrganizationMyTasksRoute,
    AuthedOrganizationNotificationsRoute: AuthedOrganizationNotificationsRoute,
    AuthedOrganizationReleaseNotesRoute: AuthedOrganizationReleaseNotesRoute,
    AuthedOrganizationIndexRoute: AuthedOrganizationIndexRoute,
    AuthedOrganizationLearningsIndexRoute:
      AuthedOrganizationLearningsIndexRoute,
    AuthedOrganizationLearningsClientsClientIdRoute:
      AuthedOrganizationLearningsClientsClientIdRoute,
    AuthedOrganizationLearningsPortfolioProjectTypeRoute:
      AuthedOrganizationLearningsPortfolioProjectTypeRoute,
  }

const AuthedOrganizationRouteRouteWithChildren =
  AuthedOrganizationRouteRoute._addFileChildren(
    AuthedOrganizationRouteRouteChildren,
  )

interface AuthedGoRouteRouteChildren {
  AuthedGoEntityEntityIdRoute: typeof AuthedGoEntityEntityIdRoute
  AuthedGoTeamsLinkStateRoute: typeof AuthedGoTeamsLinkStateRoute
}

const AuthedGoRouteRouteChildren: AuthedGoRouteRouteChildren = {
  AuthedGoEntityEntityIdRoute: AuthedGoEntityEntityIdRoute,
  AuthedGoTeamsLinkStateRoute: AuthedGoTeamsLinkStateRoute,
}

const AuthedGoRouteRouteWithChildren = AuthedGoRouteRoute._addFileChildren(
  AuthedGoRouteRouteChildren,
)

interface AuthedSettingsRouteRouteChildren {
  AuthedSettingsClientsRoute: typeof AuthedSettingsClientsRoute
  AuthedSettingsMembersRoute: typeof AuthedSettingsMembersRoute
  AuthedSettingsOrganizationsRoute: typeof AuthedSettingsOrganizationsRoute
  AuthedSettingsProcoreRoute: typeof AuthedSettingsProcoreRoute
  AuthedSettingsProfileRoute: typeof AuthedSettingsProfileRoute
  AuthedSettingsSharepointRoute: typeof AuthedSettingsSharepointRoute
  AuthedSettingsSsoRoute: typeof AuthedSettingsSsoRoute
  AuthedSettingsSuppliersRoute: typeof AuthedSettingsSuppliersRoute
  AuthedSettingsWorkspacesRoute: typeof AuthedSettingsWorkspacesRoute
  AuthedSettingsInternalCuratorRoute: typeof AuthedSettingsInternalCuratorRoute
  AuthedSettingsInternalOrganizationsRoute: typeof AuthedSettingsInternalOrganizationsRoute
  AuthedSettingsKnowledgeBaseNewFeedbackRoute: typeof AuthedSettingsKnowledgeBaseNewFeedbackRoute
  AuthedSettingsTemplatesTemplateIdRoute: typeof AuthedSettingsTemplatesTemplateIdRoute
  AuthedSettingsTemplatesNewRoute: typeof AuthedSettingsTemplatesNewRoute
  AuthedSettingsKnowledgeBaseIndexRoute: typeof AuthedSettingsKnowledgeBaseIndexRoute
  AuthedSettingsTemplatesIndexRoute: typeof AuthedSettingsTemplatesIndexRoute
  AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRoute: typeof AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRoute
  AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRoute: typeof AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRoute
}

const AuthedSettingsRouteRouteChildren: AuthedSettingsRouteRouteChildren = {
  AuthedSettingsClientsRoute: AuthedSettingsClientsRoute,
  AuthedSettingsMembersRoute: AuthedSettingsMembersRoute,
  AuthedSettingsOrganizationsRoute: AuthedSettingsOrganizationsRoute,
  AuthedSettingsProcoreRoute: AuthedSettingsProcoreRoute,
  AuthedSettingsProfileRoute: AuthedSettingsProfileRoute,
  AuthedSettingsSharepointRoute: AuthedSettingsSharepointRoute,
  AuthedSettingsSsoRoute: AuthedSettingsSsoRoute,
  AuthedSettingsSuppliersRoute: AuthedSettingsSuppliersRoute,
  AuthedSettingsWorkspacesRoute: AuthedSettingsWorkspacesRoute,
  AuthedSettingsInternalCuratorRoute: AuthedSettingsInternalCuratorRoute,
  AuthedSettingsInternalOrganizationsRoute:
    AuthedSettingsInternalOrganizationsRoute,
  AuthedSettingsKnowledgeBaseNewFeedbackRoute:
    AuthedSettingsKnowledgeBaseNewFeedbackRoute,
  AuthedSettingsTemplatesTemplateIdRoute:
    AuthedSettingsTemplatesTemplateIdRoute,
  AuthedSettingsTemplatesNewRoute: AuthedSettingsTemplatesNewRoute,
  AuthedSettingsKnowledgeBaseIndexRoute: AuthedSettingsKnowledgeBaseIndexRoute,
  AuthedSettingsTemplatesIndexRoute: AuthedSettingsTemplatesIndexRoute,
  AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRoute:
    AuthedSettingsKnowledgeBaseInternalKnowledgeBaseIdRoute,
  AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRoute:
    AuthedSettingsKnowledgeBaseTenderFeedbacksTenderFeedbackIdRoute,
}

const AuthedSettingsRouteRouteWithChildren =
  AuthedSettingsRouteRoute._addFileChildren(AuthedSettingsRouteRouteChildren)

interface AuthedProjectProjectIdArtifactsArtifactIdRouteChildren {
  AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRoute: typeof AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRoute
  AuthedProjectProjectIdArtifactsArtifactIdIndexRoute: typeof AuthedProjectProjectIdArtifactsArtifactIdIndexRoute
}

const AuthedProjectProjectIdArtifactsArtifactIdRouteChildren: AuthedProjectProjectIdArtifactsArtifactIdRouteChildren =
  {
    AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRoute:
      AuthedProjectProjectIdArtifactsArtifactIdVersionHistoryRoute,
    AuthedProjectProjectIdArtifactsArtifactIdIndexRoute:
      AuthedProjectProjectIdArtifactsArtifactIdIndexRoute,
  }

const AuthedProjectProjectIdArtifactsArtifactIdRouteWithChildren =
  AuthedProjectProjectIdArtifactsArtifactIdRoute._addFileChildren(
    AuthedProjectProjectIdArtifactsArtifactIdRouteChildren,
  )

interface AuthedProjectProjectIdArtifactsRouteRouteChildren {
  AuthedProjectProjectIdArtifactsArtifactIdRoute: typeof AuthedProjectProjectIdArtifactsArtifactIdRouteWithChildren
  AuthedProjectProjectIdArtifactsIndexRoute: typeof AuthedProjectProjectIdArtifactsIndexRoute
}

const AuthedProjectProjectIdArtifactsRouteRouteChildren: AuthedProjectProjectIdArtifactsRouteRouteChildren =
  {
    AuthedProjectProjectIdArtifactsArtifactIdRoute:
      AuthedProjectProjectIdArtifactsArtifactIdRouteWithChildren,
    AuthedProjectProjectIdArtifactsIndexRoute:
      AuthedProjectProjectIdArtifactsIndexRoute,
  }

const AuthedProjectProjectIdArtifactsRouteRouteWithChildren =
  AuthedProjectProjectIdArtifactsRouteRoute._addFileChildren(
    AuthedProjectProjectIdArtifactsRouteRouteChildren,
  )

interface AuthedProjectProjectIdSettingsRouteRouteChildren {
  AuthedProjectProjectIdSettingsIndexRoute: typeof AuthedProjectProjectIdSettingsIndexRoute
}

const AuthedProjectProjectIdSettingsRouteRouteChildren: AuthedProjectProjectIdSettingsRouteRouteChildren =
  {
    AuthedProjectProjectIdSettingsIndexRoute:
      AuthedProjectProjectIdSettingsIndexRoute,
  }

const AuthedProjectProjectIdSettingsRouteRouteWithChildren =
  AuthedProjectProjectIdSettingsRouteRoute._addFileChildren(
    AuthedProjectProjectIdSettingsRouteRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonSheetIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutComparisonIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSettingsRouteRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutSummaryRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisPositionIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesDocumentIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutCvAnalysisIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutFilesIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdGroupIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdDeliverableIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutComplianceCategoryIdIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutDeliverablesCriterionIdIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsLayoutRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdLayoutRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdDraftRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsBidIdMethodologyRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdFilesRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisAssessmentIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdChangeAnalysisIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteWithChildren
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementSupplementIdRouteWithChildren,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsDisciplinesRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdSettingsRouteRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdLevelingRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdReservationsRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdScopeOfWorkRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonSheetIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesDocumentIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdComparisonIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdFilesIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesDocumentIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdOffersSubcontractorIdFilesIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsProcurementIdRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdVersionHistoryRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsArtifactIdRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRoute
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutArtifactsRouteRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutSettingsRouteRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutInsightsRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutTasksRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainExtractionsRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainSummaryRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainWorkPackagesRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesDocumentIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutFilesIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesAmbiguityIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsRunIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsConflictIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewDomainRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsDomainRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsDeviationIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainAmbiguitiesIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainChecklistsIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainConflictsIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainContractReviewIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainLegalDeviationsIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainScopeBreakdownIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainStandardDeviationsIndexRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdClauseIdRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutmainClausesSubcategoryIdIndexRoute,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteChildren,
  )

interface AuthedProjectProjectIdWorkspacesWorkspaceIdRouteChildren {
  AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteWithChildren
  AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteWithChildren
}

const AuthedProjectProjectIdWorkspacesWorkspaceIdRouteChildren: AuthedProjectProjectIdWorkspacesWorkspaceIdRouteChildren =
  {
    AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdBidsRouteRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdContractManagementRouteRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdSubcontractorBidsRouteRouteWithChildren,
    AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdLayoutRouteWithChildren,
  }

const AuthedProjectProjectIdWorkspacesWorkspaceIdRouteWithChildren =
  AuthedProjectProjectIdWorkspacesWorkspaceIdRoute._addFileChildren(
    AuthedProjectProjectIdWorkspacesWorkspaceIdRouteChildren,
  )

interface AuthedProjectProjectIdRouteChildren {
  AuthedProjectProjectIdArtifactsRouteRoute: typeof AuthedProjectProjectIdArtifactsRouteRouteWithChildren
  AuthedProjectProjectIdSettingsRouteRoute: typeof AuthedProjectProjectIdSettingsRouteRouteWithChildren
  AuthedProjectProjectIdInsightsRoute: typeof AuthedProjectProjectIdInsightsRoute
  AuthedProjectProjectIdMembersRoute: typeof AuthedProjectProjectIdMembersRoute
  AuthedProjectProjectIdTasksRoute: typeof AuthedProjectProjectIdTasksRoute
  AuthedProjectProjectIdIndexRoute: typeof AuthedProjectProjectIdIndexRoute
  AuthedProjectProjectIdContractsSplatRoute: typeof AuthedProjectProjectIdContractsSplatRoute
  AuthedProjectProjectIdTenderPackagesSplatRoute: typeof AuthedProjectProjectIdTenderPackagesSplatRoute
  AuthedProjectProjectIdWorkspacesWorkspaceIdRoute: typeof AuthedProjectProjectIdWorkspacesWorkspaceIdRouteWithChildren
}

const AuthedProjectProjectIdRouteChildren: AuthedProjectProjectIdRouteChildren =
  {
    AuthedProjectProjectIdArtifactsRouteRoute:
      AuthedProjectProjectIdArtifactsRouteRouteWithChildren,
    AuthedProjectProjectIdSettingsRouteRoute:
      AuthedProjectProjectIdSettingsRouteRouteWithChildren,
    AuthedProjectProjectIdInsightsRoute: AuthedProjectProjectIdInsightsRoute,
    AuthedProjectProjectIdMembersRoute: AuthedProjectProjectIdMembersRoute,
    AuthedProjectProjectIdTasksRoute: AuthedProjectProjectIdTasksRoute,
    AuthedProjectProjectIdIndexRoute: AuthedProjectProjectIdIndexRoute,
    AuthedProjectProjectIdContractsSplatRoute:
      AuthedProjectProjectIdContractsSplatRoute,
    AuthedProjectProjectIdTenderPackagesSplatRoute:
      AuthedProjectProjectIdTenderPackagesSplatRoute,
    AuthedProjectProjectIdWorkspacesWorkspaceIdRoute:
      AuthedProjectProjectIdWorkspacesWorkspaceIdRouteWithChildren,
  }

const AuthedProjectProjectIdRouteWithChildren =
  AuthedProjectProjectIdRoute._addFileChildren(
    AuthedProjectProjectIdRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedOrganizationRouteRoute: typeof AuthedOrganizationRouteRouteWithChildren
  AuthedGoRouteRoute: typeof AuthedGoRouteRouteWithChildren
  AuthedSettingsRouteRoute: typeof AuthedSettingsRouteRouteWithChildren
  AuthedAcceptInvitationRoute: typeof AuthedAcceptInvitationRoute
  AuthedAddOrganizationRoute: typeof AuthedAddOrganizationRoute
  AuthedChooseOrganizationRoute: typeof AuthedChooseOrganizationRoute
  AuthedProjectProjectIdRoute: typeof AuthedProjectProjectIdRouteWithChildren
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedOrganizationRouteRoute: AuthedOrganizationRouteRouteWithChildren,
  AuthedGoRouteRoute: AuthedGoRouteRouteWithChildren,
  AuthedSettingsRouteRoute: AuthedSettingsRouteRouteWithChildren,
  AuthedAcceptInvitationRoute: AuthedAcceptInvitationRoute,
  AuthedAddOrganizationRoute: AuthedAddOrganizationRoute,
  AuthedChooseOrganizationRoute: AuthedChooseOrganizationRoute,
  AuthedProjectProjectIdRoute: AuthedProjectProjectIdRouteWithChildren,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthedRoute: AuthedRouteWithChildren,
  PTokenRoute: PTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
